import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckIdService {
  private _env: string = this.env._env;
  private url = null;

  constructor(private http: HttpClient, private env: EnvironmentService) {}

  getRfcInformation(rfc: string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Api-Key': environment[this._env]['back_end_api_token']
    })

    let qa = false;
    if (this._env === 'prod') qa = false;
    else qa = true;

    this.url = `${environment[this._env]['back_end_url']}/checkid`;

    return this.http.post<any>(this.url,
      { "rfc": rfc , "qa": qa },
      {
        headers: headers
      })
  }
}
